import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfSalaryType(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "SALARY TYPE", key: "salary_type", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.salary_type_code ?? "-",
    salary_type: item.salary_type_code ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Salary Type" />;
}
